import { render, staticRenderFns } from "./CountriesBannerInfoDesktop.vue?vue&type=template&id=1432cbf7&scoped=true&"
import script from "./CountriesBannerInfoDesktop.vue?vue&type=script&lang=ts&"
export * from "./CountriesBannerInfoDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./CountriesBannerInfoDesktop.vue?vue&type=style&index=0&id=1432cbf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1432cbf7",
  null
  
)

export default component.exports